/* GENERAL */
export const GET_GENERAL = "GET_GENERAL"
export const GET_GENERAL_SUCCESS = "GET_GENERAL_SUCCESS"
export const GET_GENERAL_FAIL = "GET_GENERAL_FAIL"

export const GET_ATTACHMENT = "GET_ATTACHMENT"
export const GET_ATTACHMENT_SUCCESS = "GET_ATTACHMENT_SUCCESS"
export const GET_ATTACHMENT_FAIL = "GET_ATTACHMENT_FAIL"

export const GET_PROFILE_ATTACHMENT = "GET_PROFILE_ATTACHMENT"
export const GET_PROFILE_ATTACHMENT_SUCCESS = "GET_PROFILE_ATTACHMENT_SUCCESS"
export const GET_PROFILE_ATTACHMENT_FAIL = "GET_PROFILE_ATTACHMENT_FAIL"

export const GET_THUMBNAIL_ATTACHMENT = "GET_THUMBNAIL_ATTACHMENT"
export const GET_THUMBNAIL_ATTACHMENT_SUCCESS = "GET_THUMBNAIL_ATTACHMENT_SUCCESS"
export const GET_THUMBNAIL_ATTACHMENT_FAIL = "GET_THUMBNAIL_ATTACHMENT_FAIL"

export const GET_VOUCHER_LIST = "GET_VOUCHER_LIST"
export const GET_VOUCHER_LIST_SUCCESS = "GET_VOUCHER_LIST_SUCCESS"
export const GET_VOUCHER_LIST_FAIL = "GET_VOUCHER_LIST_FAIL"

export const GET_SERVICE_LIST = "GET_SERVICE_LIST"
export const GET_SERVICE_LIST_SUCCESS = "GET_SERVICE_LIST_SUCCESS"
export const GET_SERVICE_LIST_FAIL = "GET_SERVICE_LIST_FAIL"

export const RESET_GENERAL_STATE = 'RESET_GENERAL_STATE';

export const RESET_ATTACHMENT_STATE = 'RESET_ATTACHMENT_STATE';

export const RESET_PROFILE_ATTACHMENT_STATE = 'RESET_PROFILE_ATTACHMENT_STATE';

export const RESET_THUMBNAIL_ATTACHMENT_STATE = 'RESET_PROFILE_ATTACHMENT_STATE';
